<div class="content ingame my-doors">

  <div class="message-panel" [@menuAnimation] *ngIf="menuIn" (@menuAnimation.done)="menuLeaves()">
    <div class="message-panel-background"></div>
    <div class="border-line">
    </div>

    <div class="message-panel-content">
      <div class="button button-tercery new-door" (click)="goToNewDoor()">NUEVA PUERTA</div>
      <div class="list-doors">
        <div class="door" *ngFor="let door of doors">
          <config-option [item]="door" (onSelect)="editDoor($event)" [display]="optionDisplay">
            <ng-template #optionDisplay let-item="item">
              <div class="option button">
                <div class="image-container"> <img [src]="item?.image" alt=""></div>
                <div class="information-container">
                  <div class="title">
                    <span class="name">{{item?.lock?.lock?.name}}</span>
                  </div>
                  <div class="info">
                    <div class="digits"><span><i class="fa fa-asterisk"></i>{{item?.lock?.digits}}</span></div>
                    <div class="time"><span><i class="fa fa-clock-o"></i>{{item?.timer?.timeStr}}</span></div>
                  </div>

                </div>
              </div>
            </ng-template>
          </config-option>
        </div>
      </div>
    </div>

  </div>



</div>
